export default __webpack_public_path__ + "static/media/003-datos-de-contacto.0b03d1d5.png";